__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.3.1-03052026444/_next/";